// extracted by mini-css-extract-plugin
export default {"content":"index_content_IAyvO","errorImg":"index_errorImg_7y-c3","errorWords":"index_errorWords_Z7lVf","button":"index_button_nK3L3"};